import { FormControl } from "@mui/material";
import SelectUI from "./SelectUI.jsx";
import FormInputOuter from "../FormInputOuter";

const SelectInput = (props) => {
  return (
    <FormInputOuter {...props}>
      <SelectUI {...props} />
    </FormInputOuter>
  );
};

export const SelectWithInput = (props) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <SelectUI {...props} />
    </FormControl>
  );
};

export default SelectInput;
